let resumeData = {
    "imagebaseurl":"https://niraulapm.github.io/",
    "name": "Prashanta Niraula, Ph.D",
    "role": "Research Scientist",
    "linkedinId":"prashanta-niraula-phd-b1ba3969",
    "skypeid": "Your skypeid",
    "roleDescription": " I am currently workinga as Accelerator Scientist at Michigan Ion Beam Laboratory, University of Michigan. I am a self taught programmer.",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/prashanta-niraula-phd-b1ba3969/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/niraulapm",
          "className":"fa fa-github"
        },
        {
          "name":"skype",
          "url":"http://twitter.com/prashantniraula",
          "className":"fa fa-twitter"
        }
      ],
    "aboutme":"Collaboration and knowledge sharing is at the core of my professional ethos. I believe that by working together and exchanging ideas, we can achieve breakthroughs that make a real impact.",
    "address":"Ann Arbor, MI, USA",
    "website":"https://niraulapm.github.io",
    "education":[
      {
        "UniversityName":"Western Michigan University",
        "specialization":"Physics, PhD",
        "MonthOfPassing":"Dec",
        "YearOfPassing":"2020",
        "Achievements":"Dissertation title : Enhancement of critical current density in high temperature superconductor by ion beam irradiation."
      },
      {
        "UniversityName":"Tribhuvan University",
        "specialization":"M.Sc. in Physics",
        "MonthOfPassing":"",
        "YearOfPassing":"2012",
        "Achievements":"Elective courses: Solid State Physics, Atmospheric Physics"
      }
    ],
    "work":[
      {
        "CompanyName":"Michigan Ion Beam Laboratory, University of Michigan",
        "specialization":"Accelerator Scientist",
        "MonthOfLeaving":"Since Feb",
        "YearOfLeaving":"2021 - Present",
        "Achievements":"Design, build, and maintain scientific equipment control systems in the laboratory. Maintain servers, webpages, labView codes and local network of the laboaraty. Maintain data acquisition system, analyze experimental data, make plots and make scientific reports."
      },
      {
        "CompanyName":"Western Michigan University",
        "specialization":"Research/Teaching Assistant",
        "MonthOfLeaving":"Sept 2013",
        "YearOfLeaving":"- Dec 2020",
        "Achievements":"Carry out mathematical calculation,computer simulation,acquiring data, analysing and plotting data, fitting the experimental data with the theoretical model. Grade assigned homework, quizzes, and exams of undergraduate physics courses"
      }
    ],
    "skillsDescription":"Programming languages and tools",
    "skills":[
      {
        "skillname":"Python"
      },
      {
        "skillname":"SQL"
      },
      {
        "skillname":"Git"
      }
    ],
    "portfolio":[
      {
        "name":"Magnanometer data analysis using python",
        "description":"In this project pandas,matplotlib and scipy libraries are used for reading .dat file, and fitting the data and doing necessary extrapolation.",
        "imgurl":"images/portfolio/Squid.png",
        "url":"https://github.com/niraulapm/squid_data_analysis"
      },
      {
        "name":"Real-state price predictor",
        "description":"In this project, location and other features of properties put on sale is extracted from the web using python library Beautifulsoup. Further refinining of the data is done by crateing a pipeline and at the end data in .csv formatt is obtained. Different data analysis libraries and regular expression engine in python is used to do the necessary data cleaning and feature engineering.",
        "imgurl":"images/portfolio/Realstate.png",
        "url":"https://github.com/niraulapm/Realestate-price-predictor"
        
      },
      {
        "name":"Amazon item rating",
        "description":"In this project plotly library is used to visualize the product rating through interactive box and bar plots.",  
        "imgurl":"images/portfolio/mazon.jpeg",
        "url":"https://github.com/niraulapm/amazon_rating_visualization"
      },
      {
        "name":"Github webpage",
        "description":"In this project, React app is deployed as a static portfolio page in github.",
        "imgurl":"images/portfolio/github.png",
        "url":"https://niraulapm.github.io/"
      }
    ],
    "testimonials":[
      {
        "description":"It does not matter how slowly you go as long as you do not stop.",
        "name":"Confucius"
      },
      {
        "description":"The best time is now.",
        "name":"Oprah"
      }
    ]
  }
  
  export default resumeData